import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AboutPage from './components/about'
import ContactPage from './components/contact'
import HomePage from './components/home'
import LucyYak from './components/lucy'
import ScrollToTop from "./components/scrolltop";
import Footer from './components/footer';

import './App.css';

const Portfolio = () => (

  <div className="h-full w-full">
    <Router>
      <div className="min-h-[calc(100vh-128px)]">
        <ScrollToTop />
       
        <Routes>
          <Route path="/" element={<Home />}></Route>
          <Route path="/about" element={<About />}></Route>
          <Route path="/contact" element={<Contact />}></Route>
          <Route path="/lucy" element={<Lucy />}></Route>
        </Routes>
      </div>
      <Footer/>
    </Router>
  </div>
);

const Home = () => (
  <HomePage />
);

const About = ({ match }) => (
  <AboutPage />
);

const Contact = ({ match }) => (
  <ContactPage />
);

const Lucy = ({ match }) => (
  <LucyYak />
);

export default Portfolio